import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {

};

const getters = {

};

const actions = {
    async getBroadcastOptions(context, data) {
        return await axios.post(`${backendUrl()}/getBroadcastOptions`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async sendBroadcastMessage(context, data) {
        return await axios.post(`${backendUrl()}/sendBroadcastMessage`, data,
        {
            headers: { 
                'Content-Type': 'multipart/form-data',
                'Authorization': "bearer " + vuecookie.get('token') 
            }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    },

    async getAffectedCustomers(context, data) {
        return await axios.post(`${backendUrl()}/getAffectedCustomers`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    }
};

const mutations = {
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
